import { Box, ButtonOutline, Flex } from 'front-end/src/components'
import { EventModelAsStudent } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import {
  getStatus,
  StatusEventStatusType
} from 'front-end/src/pages/manage-events/components/event-status/EventStatus'
import React, { FC } from 'react'
import { brandColors } from 'shared/basicPalette'

import { Trans } from '@lingui/macro'

import { linkBuilder } from '../../../../../../shared/linkBuilder'
import { navigateTo } from '../../../../app/util/appHistory'
import { FlexProps, BoxProps, ButtonProps } from '@chakra-ui/react'

type EventRSVPProps = FlexProps & {
  event: EventModelAsStudent
}

const FlexWrapper: FC<FlexProps> = (props) => (
  <Flex direction="column" alignItems="center" {...props} />
)
const CountTitle: FC<BoxProps & { dataTest?: string }> = ({
  dataTest,
  ...props
}) => <Box fontSize="24px" fontWeight="500" data-test={dataTest} {...props} />
const Description: FC<BoxProps> = (props) => (
  <Box fontSize="12px" pt="4px" {...props} />
)

const EventRSVP: FC<EventRSVPProps> = ({ event }) => {
  if (getStatus(event) === StatusEventStatusType.DRAFT) return null

  const isCompleted = getStatus(event) === StatusEventStatusType.COMPLETED

  const openAttendance = (ev) => {
    navigateTo(linkBuilder.manageEvent(event.id, false, 'attendance'))
    ev.stopPropagation()
  }

  const RecordBtn: FC<ButtonProps> = () => {
    return (
      <ButtonOutline
        onClick={(ev) => {
          navigateTo(linkBuilder.manageEvent(event.id, false, 'attendance'))
          ev.stopPropagation()
        }}
        dataTest="RecordAttendanceButton"
      >
        <Trans>Record attendance</Trans>
      </ButtonOutline>
    )
  }

  const Attended: FC<FlexProps> = (props) => {
    return (
      <FlexWrapper
        color={brandColors.blue[500]}
        onClick={openAttendance}
        {...props}
      >
        <CountTitle dataTest="AttendeesCount">
          {event.attendeesCount}
        </CountTitle>
        <Description>
          <Trans>Attending</Trans>
        </Description>
      </FlexWrapper>
    )
  }

  const Invited: FC<FlexProps> = (props) => {
    return (
      <FlexWrapper
        color={brandColors.grey[400]}
        onClick={openAttendance}
        {...props}
      >
        <CountTitle dataTest="InviteesCount">{event.inviteesCount}</CountTitle>
        <Description>
          <Trans>Invited</Trans>
        </Description>
      </FlexWrapper>
    )
  }

  const Present: FC<FlexProps> = (props) => {
    return (
      <FlexWrapper
        color={brandColors.blue[500]}
        onClick={openAttendance}
        {...props}
      >
        <CountTitle>{event.presentCount}</CountTitle>
        <Description>
          <Trans>Attended</Trans>
        </Description>
      </FlexWrapper>
    )
  }

  return (
    <Flex alignItems="center">
      {!isCompleted && (
        <Flex>
          <Invited />
          <Attended ml="32px" />
        </Flex>
      )}
      {isCompleted && event.presentCount === 0 && <RecordBtn />}
      {isCompleted && event.presentCount > 0 && <Present />}
    </Flex>
  )
}

export default EventRSVP
